import React from "react";
import "./PayoutMakerDashBoard.css";
import { Col, Row } from "react-bootstrap";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PayoutMakerDashboardList from "./PayoutMakerDashboardList";
import { Routes, Route, redirect, Navigate } from "react-router-dom";
import useWindowSize from "../../utils/useWindowSize";
import PayoutMakerMobileHeader from "./PayoutMakerMobileHeader";
import CustomLogout from "../CustomLogout/CustomLogout";
import { connect } from "react-redux";
import PayoutManagement from "../PayoutManagement/PayoutManagement";
import PricingManagement from "../PricingManagement/PricingManagement";
import PricingCreate from "../PricingManagement/PricingCreate/PricingCreate";
import PricingviewData from "../PricingManagement/PricingCreate/PricingviewData";
import LanListbypartner from "../PayoutManagement/PayoutListDetails/LanListbypartner";
import PricingCreateQuery from "../PricingManagement/PricingCreate/PricingCreateQuery";
import PartnerListDetails from "../PayoutManagement/PayoutListDetails/PartnerListDetails";
import ChanalWiseReport from "../PayoutManagement/ChanalWiseReport";
import LanListDetailChanalwise from "../PayoutManagement/payouLanlistDetailschanalwise/LanListDetailChanalwise";
// import EditPartner from "../PartnerManagement/EditPartner/EditPartner";

// const PartnerManagement = React.lazy(() =>
//   import("../PartnerManagement/PartnerManagement")
// );


const routes = [

  {
    path: "/PartnerPayout",
    element: <PayoutManagement />,
  },
 
  {
    path: "/PartnerPayout/generate-report",
    element: <PayoutManagement />,
  },  
  {
    path: "/PartnerPayout/generate-report/Details/:fileName/:monthlyReportId",
    element: <PartnerListDetails />,
  },
  {
    path: "/PartnerPayout/generate-report-channelwise",
    element:<ChanalWiseReport />
  },
  {
    path: "/PartnerPayout/generate-report-channelwise/Details/:fileName/:reportId",
    element: <LanListDetailChanalwise />,
  },

  {
    path: "/PartnerPayout/generate-report/Details/:fileName/:monthlyReportId/landata/:partner",
    element: <LanListbypartner />,
  },

  {
    path: "/PartnerPricing",
    element: <PricingManagement makerAction={true} />,
  },

  {
    path: "/AddPartnerPricing",
    element: <PricingCreate />,
  },
  {
    path: "/ResolvePricing",
    element: <PricingCreateQuery />,
  },

  {
    path: "/PartnerPricingView",
    element: <PricingviewData checkerAction={false} queryAction={true} />,
  },
  
];

const PayoutMakerDashboard = (props) => {
  const { width } = useWindowSize();
  return (
    <div>
      {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="dashboard-cet-mobile">
            <PayoutMakerMobileHeader />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="dashboard-content">
          <Col md={3} className="Left-side-blue">
            <PayoutMakerDashboardList />
          </Col>

          <Col md={9} className="right-side-blue">
            <React.Suspense
              fallback={
                <div className="cet-dashobard-loader">
                  <Spin
                    className="cet-loader"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              }
            >
              <Routes>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </React.Suspense>
            {/* <Routes>
              {routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes> */}
            <Routes>
              {/* <Route
                path="/PartnerManagement"
                element={<PartnerManagement />}
              />
              <Route path="/edit-partner/:id" element={<EditPartner />} /> */}

              {/* <Route path="/leadManagement" element={<LeadManagements />} /> */}
            </Routes>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps)(PayoutMakerDashboard);
